import * as React from 'react';
import classNames from 'classnames';

export interface ITableHeadCellProps {
    /** className to append */
    className?: string;
    /** Should this column always be hidden */
    hidden?: boolean;
    /** Hiding priority index */
    priority?: number;
    /** Desired width of the column */
    width?: number;
    /** Desired min-width of the column */
    minWidth?: number;
    /** Desired max-width of the column */
    maxWidth?: number;
    /** Special checkbox column that gets never hidden */
    checkbox?: boolean;
    /** Display sorting indicators */
    sortable?: boolean;
    /** Sorting direction for sortable column */
    sorted?: 'asc' | 'desc';
    /** Click event for sortable column */
    onSort?: (column) => void;
}

/**
 * Use this within TableHead component to render a header cell.
 */
export default class TableHeadCell extends React.Component<ITableHeadCellProps, {}> {
    static displayName: string = 'TableHeadCell';

    public render () {
        return (
            <div
                className={classNames('table-head-cell-container', this.props.className)}
                style={{
                    width: this.props.width,
                    minWidth: this.props.minWidth,
                    maxWidth: this.props.maxWidth,
                }}
            >
                {this.props.children}
            </div>
        );
    }
}
